<div class="dcf-hero dcf-hero-default">
	<!-- TemplateEndEditable -->
	<div class="dcf-hero-group-1">
	  <div class="dcf-breadcrumbs-wrapper">
		<nav class="dcf-breadcrumbs" id="dcf-breadcrumbs" role="navigation" aria-label="breadcrumbs">
		  <!-- TemplateBeginEditable name="breadcrumbs" -->
		  <ol>
			<li><a href="https://www.unl.edu/">Nebraska</a></li>
			<li><a href="/">TCAN / VITA Lincoln</a></li>
			<li>Need Assistance</li>
			<li><span aria-current="page">Questionnaire</span></li>
		  </ol>
		  <!-- TemplateEndEditable -->
		</nav>
	  </div>
	  <header class="dcf-page-title" id="dcf-page-title">
		<!-- TemplateBeginEditable name="pagetitle" -->
		<h1>Questionnaire</h1>
		<!-- TemplateEndEditable -->
	  </header>
	  <!-- TemplateBeginEditable name="herogroup1" -->
	  <!-- TemplateEndEditable -->
	</div>
	<!-- TemplateBeginEditable name="herogroup2" -->
	<div class="dcf-hero-group-2">
	</div>
	<!-- TemplateEndEditable -->
  </div>
  <div class="dcf-main-content dcf-wrapper">
  
	<!-- Questions -->
<h2>Can VITA Help You?</h2>
<p><b>Please note:</b> The scope of work that can be done within a VITA site is defined by the IRS. If your return is considered “out of scope” for a site, our VITA Volunteers will not be able to prepare your return.</p>


<form class="cmxform"
	autocomplete="off"
	name="form"
	id="vitaQuestionnaireForm" 
	ng-submit="submitQuestionnaireForm($event)">

	<div class="form-radio">
    <app-custom-radio-button
    question="Will you require a Depreciation Schedule?"
    name="Deprecation"
    [(ngModel)]="responses[1]"
    [buttons]="yesNoButtons"
    ></app-custom-radio-button>

		<!-- <p class="form-required dcf-mb-0">Will you require a Depreciation Schedule?</p>
		<div>
			<div class="dcf-btn-group" data-toggle="buttons">
				<label class="dcf-btn dcf-btn-secondary"
					name="1"
					ng-model="responses[1]" 
					uib-btn-radio="'1'"
					type="radio"
					required>Yes
				</label>
				<label class="dcf-btn dcf-btn-secondary"
					name="1"
					ng-model="responses[1]" 
					uib-btn-radio="'2'"
					type="radio"
					required>No
				</label>
			</div>
		</div> -->
		<p class="cant-help-text" [hidden]="responses[1] != '1'">Sorry, VITA can't prepare taxes requiring a depreciation schedule.</p>
	</div>

	<div class="form-radio">
    <app-custom-radio-button
    question="Will you require a Schedule F (Farm)?"
    name="Farm"
    [(ngModel)]="responses[2]"
    [buttons]="yesNoButtons"
    ></app-custom-radio-button>

		<!-- <p class="form-required dcf-mb-0">Will you require a Schedule F (Farm)?</p>
		<div>
			<div class="dcf-btn-group" data-toggle="buttons">
				<label class="dcf-btn dcf-btn-secondary"
					name="2"
					ng-model="responses[2]"
					uib-btn-radio="'1'"
					type="radio"
					required>Yes
				</label>
				<label class="dcf-btn dcf-btn-secondary"
					name="2"
					ng-model="responses[2]"
					uib-btn-radio="'2'"
					type="radio"
					required>No
				</label>
			</div>
		</div> -->
		<p class="cant-help-text" [hidden]="responses[2] != '1'">Sorry, VITA can't prepare taxes requiring a schedule F.</p>
	</div>

	<div class="form-radio">
    <app-custom-radio-button
    question="Are you self-employed or own a home-based business?"
    name="Home-based"
    [(ngModel)]="responses[3]"
    [buttons]="yesNoButtons"
    ></app-custom-radio-button>
    
		<!-- <p class="form-required dcf-mb-0">Are you self-employed or own a home-based business?</p>
		<div>
			<div class="dcf-btn-group" data-toggle="buttons">
				<label class="dcf-btn dcf-btn-secondary"
					name="3"
					ng-model="responses[3]"
					uib-btn-radio="'1'"
					type="radio"
					required>Yes
				</label>
				<label class="dcf-btn dcf-btn-secondary"
					name="3"
					ng-model="responses[3]"
					uib-btn-radio="'2'"
					type="radio"
					required>No
				</label>
			</div>
		</div> -->
	</div>

	<div class="form-radio" [hidden]="responses[3] != '1'">
    <app-custom-radio-button
    question="Does your home-based business or self-employment have a net loss?"
    name="NetLoss"
    [(ngModel)]="responses[4]"
    [buttons]="yesNoButtons"
    ></app-custom-radio-button>

		<!-- <p class="form-required dcf-mb-0">Does your home-based business or self-employment have a net loss?</p>
		<div>
			<div class="dcf-btn-group" data-toggle="buttons">
				<label class="dcf-btn dcf-btn-secondary"
					name="4"
					ng-model="responses[4]"
					uib-btn-radio="'1'"
					type="radio"
					required>Yes
				</label>
				<label class="dcf-btn dcf-btn-secondary"
					name="4"
					ng-model="responses[4]"
					uib-btn-radio="'2'"
					type="radio"
					required>No
				</label>
			</div>
		</div> -->
		<p class="cant-help-text" [hidden]="responses[4] != '1'">Sorry, VITA can't prepare taxes when the home-based business has a net loss.</p>
	</div>

	<div class="form-radio" ng-show="responses[3] == 1">
    <app-custom-radio-button
    question="Does your home-based business or self-employment have more than $10,000 in expenses?"
    name="Expenses"
    [(ngModel)]="responses[5]"
    [buttons]="yesNoButtons"
    ></app-custom-radio-button>

		<!-- <p class="form-required dcf-mb-0">Does your home-based business or self-employment have more than $10,000 in expenses?</p>
		<div>
			<div class="dcf-btn-group" data-toggle="buttons">
				<label class="dcf-btn dcf-btn-secondary"
					name="5"
					ng-model="responses[5]"
					uib-btn-radio="'1'"
					type="radio"
					required>Yes
				</label>
				<label class="dcf-btn dcf-btn-secondary"
					name="5"
					ng-model="responses[5]"
					uib-btn-radio="'2'"
					type="radio"
					required>No
				</label>
			</div>
		</div> -->
		<p class="cant-help-text" [hidden]="responses[5] != '1'">Sorry, VITA can't prepare taxes when the home-based business has more than $10,000 in expenses.</p>
	</div>

	<div class="form-radio" [hidden]="responses[3] != '1'">
    <app-custom-radio-button
    question="Does your home-based business or self-employment have self-employed, SEP, SIMPLE, or qualified retirement plans?"
    name="retirementPlans"
    [(ngModel)]="responses[6]"
    [buttons]="yesNoButtons"
    ></app-custom-radio-button>
		<!-- <p class="form-required dcf-mb-0">Does your home-based business or self-employment have self-employed, SEP, SIMPLE, or qualified retirement plans?</p>
		<div>
			<div class="dcf-btn-group" data-toggle="buttons">
				<label class="dcf-btn dcf-btn-secondary"
					name="6"
					ng-model="responses[6]"
					uib-btn-radio="'1'"
					type="radio"
					required>Yes
				</label>
				<label class="dcf-btn dcf-btn-secondary"
					name="6"
					ng-model="responses[6]"
					uib-btn-radio="'2'"
					type="radio"
					required>No
				</label>
			</div>
		</div> -->
		<p class="cant-help-text" [hidden]="responses[6] != '1'">Sorry, VITA can't prepare taxes when the home-based business has retirement plans.</p>
	</div>

	<div class="form-radio" [hidden]="responses[3] != '1'">
    <app-custom-radio-button
    question="Does your home-based business or self-employment have employees?"
    name="Employees"
    [(ngModel)]="responses[7]"
    [buttons]="yesNoButtons"
    ></app-custom-radio-button>
		<!-- <p class="form-required dcf-mb-0">Does your home-based business or self-employment have employees?</p>
		<div>
			<div class="dcf-btn-group" data-toggle="buttons">
				<label class="dcf-btn dcf-btn-secondary"
					name="7"
					ng-model="responses[7]"
					uib-btn-radio="'1'"
					type="radio"
					required>Yes
				</label>
				<label class="dcf-btn dcf-btn-secondary"
					name="7"
					ng-model="responses[7]"
					uib-btn-radio="'2'"
					type="radio"
					required>No
				</label>
			</div>
		</div> -->
		<p class="cant-help-text" [hidden]="responses[7] != '1'">Sorry, VITA can't prepare taxes when the home-based business has employees.</p>
	</div>

	<div class="form-radio">
    <app-custom-radio-button
    question="Will your return have casualty losses?"
    name="casualty"
    [(ngModel)]="responses[8]"
    [buttons]="yesNoButtons"
    ></app-custom-radio-button>

		<!-- <p class="form-required dcf-mb-0">Will your return have casualty losses?</p>
		<div>
			<div class="dcf-btn-group" data-toggle="buttons">
				<label class="dcf-btn dcf-btn-secondary"
					name="8"
					ng-model="responses[8]"
					uib-btn-radio="'1'"
					type="radio"
					required>Yes
				</label>
				<label class="dcf-btn dcf-btn-secondary"
					name="8"
					ng-model="responses[8]"
					uib-btn-radio="'2'"
					type="radio"
					required>No
				</label>
			</div>
		</div> -->
		<p class="cant-help-text" [hidden]="responses[8] != '1'">Sorry, VITA can't prepare taxes which will have casualty losses.</p>
	</div>

	<div class="form-radio">
    <app-custom-radio-button
    question="Will your return have theft losses?"
    name="theft"
    [(ngModel)]="responses[9]"
    [buttons]="yesNoButtons"
    ></app-custom-radio-button>

		<!-- <p class="form-required dcf-mb-0">Will your return have theft losses?</p>
		<div>
			<div class="dcf-btn-group" data-toggle="buttons">
				<label class="dcf-btn dcf-btn-secondary"
					name="9"
					ng-model="responses[9]"
					uib-btn-radio="'1'"
					type="radio"
					required>Yes
				</label>
				<label class="dcf-btn dcf-btn-secondary"
					name="9"
					ng-model="responses[9]"
					uib-btn-radio="'2'"
					type="radio"
					required>No
				</label>
			</div>
		</div> -->
		<p class="cant-help-text" [hidden]="responses[9] != '1'">Sorry, VITA can't prepare taxes which will have theft losses.</p>
	</div>

	<div class="form-radio">
    <app-custom-radio-button
    question="Will you require a Schedule E (rental income)?"
    name="rental"
    [(ngModel)]="responses[10]"
    [buttons]="yesNoButtons"
    ></app-custom-radio-button>

		<!-- <p class="form-required dcf-mb-0">Will you require a Schedule E (rental income)?</p>
		<div>
			<div class="dcf-btn-group" data-toggle="buttons">
				<label class="dcf-btn dcf-btn-secondary"
					name="10"
					ng-model="responses[10]"
					uib-btn-radio="'1'"
					type="radio"
					required>Yes
				</label>
				<label class="dcf-btn dcf-btn-secondary"
					name="10"
					ng-model="responses[10]"
					uib-btn-radio="'2'"
					type="radio"
					required>No
				</label>
			</div>
		</div> -->
	</div>

	<div class="form-radio">
    <app-custom-radio-button
    question="Will you require a Schedule K-1 (partnership or trust income)?"
    name="trust"
    [(ngModel)]="responses[11]"
    [buttons]="yesNoButtons"
    ></app-custom-radio-button>

		<!-- <p class="form-required dcf-mb-0">Will you require a Schedule K-1 (partnership or trust income)?</p>
		<div>
			<div class="dcf-btn-group" data-toggle="buttons">
				<label class="dcf-btn dcf-btn-secondary"
					name="11"
					ng-model="responses[11]"
					uib-btn-radio="'1'"
					type="radio"
					required>Yes
				</label>
				<label class="dcf-btn dcf-btn-secondary"
					name="11"
					ng-model="responses[11]"
					uib-btn-radio="'2'"
					type="radio"
					required>No
				</label>
			</div>
		</div> -->
	</div>

	<div class="form-radio">
    <app-custom-radio-button
    question="Do you have income from dividends, capital gains, or minimal brokerage transactions?"
    name="brokerage"
    [(ngModel)]="responses[12]"
    [buttons]="yesNoButtons"
    ></app-custom-radio-button>
		<!-- <p class="form-required dcf-mb-0">Do you have income from dividends, capital gains, or minimal brokerage transactions?</p>
		<div>
			<div class="dcf-btn-group" data-toggle="buttons">
				<label class="dcf-btn dcf-btn-secondary"
					name="12"
					ng-model="responses[12]"
					uib-btn-radio="'1'"
					type="radio"
					required>Yes
				</label>
				<label class="dcf-btn dcf-btn-secondary"
					name="12"
					ng-model="responses[12]"
					uib-btn-radio="'2'"
					type="radio"
					required>No
				</label>
			</div>
		</div> -->
	</div>

	<div class="form-radio">
    <app-custom-radio-button
    question="Will your return involve a current bankruptcy?"
    name="bankruptcy"
    [(ngModel)]="responses[13]"
    [buttons]="yesNoButtons"
    ></app-custom-radio-button>
		<!-- <p class="form-required dcf-mb-0">Will your return involve a current bankruptcy?</p>
		<div>
			<div class="dcf-btn-group" data-toggle="buttons">
				<label class="dcf-btn dcf-btn-secondary"
					name="13"
					ng-model="responses[13]"
					uib-btn-radio="'1'"
					type="radio"
					required>Yes
				</label>
				<label class="dcf-btn dcf-btn-secondary"
					name="13"
					ng-model="responses[13]"
					uib-btn-radio="'2'"
					type="radio"
					required>No
				</label>
			</div>
		</div> -->
	</div>

	<div class="form-radio">
    <app-custom-radio-button
    question="Will your return involve income from more than one state?"
    name="States"
    [(ngModel)]="responses[14]"
    [buttons]="yesNoButtons"
    ></app-custom-radio-button>

		<!-- <p class="form-required dcf-mb-0">Will your return involve income from more than one state?</p>
		<div>
			<div class="dcf-btn-group" data-toggle="buttons">
				<label class="dcf-btn dcf-btn-secondary"
					name="14"
					ng-model="responses[14]"
					uib-btn-radio="'1'"
					type="radio"
					required>Yes
				</label>
				<label class="dcf-btn dcf-btn-secondary"
					name="14"
					ng-model="responses[14]"
					uib-btn-radio="'2'"
					type="radio"
					required>No
				</label>
			</div>
		</div> -->
	</div>

	<div class="form-radio">
    <app-custom-radio-button
    question="Will your return involve sold cryptocurrency?"
    name="cryptocurrency"
    [(ngModel)]="responses[15]"
    [buttons]="yesNoButtons"
    ></app-custom-radio-button>

		<!-- <p class="form-required dcf-mb-0">Will your return involve sold cryptocurrency?</p>
		<div>
			<div class="dcf-btn-group" data-toggle="buttons">
				<label class="dcf-btn dcf-btn-secondary"
					name="15"
					ng-model="responses[15]"
					uib-btn-radio="'1'"
					type="radio"
					required>Yes
				</label>
				<label class="dcf-btn dcf-btn-secondary"
					name="15"
					ng-model="responses[15]"
					uib-btn-radio="'2'"
					type="radio"
					required>No
				</label>
			</div>
		</div> -->
		<p class="cant-help-text" [hidden]="responses[15] != '1'">Sorry, VITA can't prepare taxes that involve sold cryptocurrency.</p>
	</div>

	<div class="dcf-mt-6 dcf-mb-6">
		<p class="can-help-text" [hidden]="!appointmentIsInScope()">Yes, VITA should be able to prepare your taxes!</p>
		<p class="cant-help-text" [hidden]="appointmentIsInScope()">Sorry, VITA cannot prepare your taxes.</p>
		<input type="submit" class="dcf-btn dcf-btn-primary" (click)="scheduleAppointment()" value="Schedule An Appointment" [disabled]="!appointmentIsInScope()" />
	</div>
</form>
</div>